module.exports = __webpack_public_path__ + "static/media/ENGLong3w427@2x.3e5a8c8b.webp";